import React, { useState } from "react";
import { PageContainer } from "./Appointments.styled";
import { Paginator, Content, FiltersContainer } from "./components";
import { useAppointmentsPage } from "../../hooks/useAppointmentsPage";

const Appointments = () => {
  const [mode, setMode] = useState("grid");
  const {
    loading,
    filtersLoading,
    error,
    isEmpty,
    appointments,
    appointmentsMeta,
    filters,
    filterHandlers,
    filterUI,
    handlePageChange,
    handleItemsPerPageChange,
    handleRefresh,
  } = useAppointmentsPage();

  return (
    <PageContainer>
      <FiltersContainer
        mode={mode}
        setMode={setMode}
        loading={filtersLoading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
      />
      <Content mode={mode} loading={loading} error={error} isEmpty={isEmpty} appointments={appointments} onRefresh={handleRefresh} />
      <Paginator
        meta={appointmentsMeta}
        onPageChange={handlePageChange}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
    </PageContainer>
  );
};

export default Appointments;
